"use client";
import { Typography } from "antd";
import Image from "next/image";
import React, { useState } from "react";
import { Mousewheel, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { ourTeamContents } from "./ourTeamContents";

const ACTIVE_SLIDE_SCALE = 1.25;
const DISTANT_SLIDE_SCALE = 0.75;
const SLIDE_Z_INDEX_BASE = 30;
const SLIDE_BASE_Y_PX = 60;
const SLIDE_Y_STEP_PX = -20;

const OurTeamSlider = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { Title } = Typography;

  return (
    <div className="relative w-full h-auto flex items-center justify-center">
      <Swiper
        breakpoints={{
          360: { slidesPerView: 3, spaceBetween: 20 },
          480: { slidesPerView: 5, spaceBetween: 20 },
          564: { slidesPerView: 5, spaceBetween: 10 },
          640: { slidesPerView: 5, spaceBetween: 20 },
        }}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
        centeredSlides={true}
        modules={[Pagination, Mousewheel]}
        pagination={{
          clickable: true,
        }}
        initialSlide={Math.floor(ourTeamContents.length / 2)}
        className="ourTeamSlider"
        style={{
          display: "flex",
          alignItems: "center",
          justifyItems: "center",
          width: "100%",
        }}
        dir="rtl"
      >
        {ourTeamContents.map((item, index) => {
          const distance =
            Math.abs(index - activeIndex) > ourTeamContents.length / 2
              ? ourTeamContents.length - Math.abs(index - activeIndex)
              : Math.abs(index - activeIndex);

          let scale = 0.8;
          if (distance === 0) scale = ACTIVE_SLIDE_SCALE;
          else if (distance === 1) scale = 1;
          else if (distance === 2) scale = DISTANT_SLIDE_SCALE;

          const zIndex = SLIDE_Z_INDEX_BASE - distance;
          const translateY = SLIDE_BASE_Y_PX - distance * SLIDE_Y_STEP_PX;

          return (
            <SwiperSlide
              key={item.id}
              className="transition-all duration-300 flex justify-center items-center"
              style={{
                zIndex,
                transform: `scale(${scale}) translateY(${translateY}px)`,
                transformOrigin: "center center",
              }}
            >
              <div className="flex flex-col gap-2 items-center text-center">
                <div className="flex bg-[url(/assets/images/aboutUsPage/borderImage.png)] bg-cover bg-center w-15 h-15 sm:w-16 sm:h-16 mid:!w-20 mid:!h-20 rounded-full">
                  <Image
                    alt={item.title}
                    src={item.url}
                    width={100}
                    height={100}
                    className="w-14 h-14 sm:w-16 sm:h-16 mid:!w-20 mid:!h-20 rounded-full object-cover"
                  />
                </div>
                {index === activeIndex && (
                  <div className="flex flex-col gap-0">
                    <Title
                      level={3}
                      className="H3 !text-tiny truncate flex items-center justify-center"
                    >
                      {item.title}
                    </Title>
                    <p className="!text-tiny text-center text-regal-black-light">
                      {item.description}
                    </p>
                  </div>
                )}
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default OurTeamSlider;
